export const ARTICLE_META_DESCRIPTION_MIN_LENGTH = 100
export const ARTICLE_META_DESCRIPTION_MAX_LENGTH = 160

function codePoints(value) {
  return Array.from(value)
}

export function articlePlainText(value) {
  return String(value ?? '')
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/!\[[^\]]*]\([^)]*\)/g, ' ')
    .replace(/\[([^\]]+)]\([^)]*\)/g, '$1')
    .replace(/[#*_`>|]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function truncateArticleMetaDescription(value) {
  const normalized = articlePlainText(value)
  const characters = codePoints(normalized)
  if (characters.length <= ARTICLE_META_DESCRIPTION_MAX_LENGTH) return normalized

  let sentenceBoundary = -1
  for (
    let index = ARTICLE_META_DESCRIPTION_MIN_LENGTH - 1;
    index < ARTICLE_META_DESCRIPTION_MAX_LENGTH;
    index += 1
  ) {
    if (/[.!?。！？]/u.test(characters[index])) sentenceBoundary = index + 1
  }
  if (sentenceBoundary >= ARTICLE_META_DESCRIPTION_MIN_LENGTH) {
    return characters.slice(0, sentenceBoundary).join('')
  }

  let truncated = characters.slice(0, ARTICLE_META_DESCRIPTION_MAX_LENGTH - 1).join('')
  const wordBoundary = truncated.lastIndexOf(' ')
  if (wordBoundary >= ARTICLE_META_DESCRIPTION_MIN_LENGTH) truncated = truncated.slice(0, wordBoundary)
  truncated = truncated.replace(/[\s,:;,、。.!?…—-]+$/u, '')
  return `${truncated}…`
}

export function articleMetaDescription(article) {
  const excerpt = articlePlainText(article?.excerpt)
  if (codePoints(excerpt).length >= ARTICLE_META_DESCRIPTION_MIN_LENGTH) {
    return truncateArticleMetaDescription(excerpt)
  }

  const body = articlePlainText(article?.body)
  if (codePoints(body).length >= ARTICLE_META_DESCRIPTION_MIN_LENGTH) {
    return truncateArticleMetaDescription(body)
  }

  const combined = [body, excerpt]
    .filter((value, index, values) => value && values.indexOf(value) === index)
    .join(' ')
  return truncateArticleMetaDescription(combined)
}
